import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

import Subscription from '../../models/Subscription';

async function deleteSubscription(
  subscription: Subscription,
  auth: Authentication
): Promise<void> {
  try {
    const subscriptionId = subscription.id;
    await HttpClient.delete(
      '/subscription',
      {
        subscriptionId,
      },
      auth.token,
      {
        'x-api-key': subscription.apiKey,
      }
    );
    return;
  } catch (e) {
    console.log('error: ', e);
    throw new DeleteSubscriptionFailure();
  }
}

export class DeleteSubscriptionFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default deleteSubscription;
